/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import { Redirect, match } from 'react-router-dom'
import { includes, split, findIndex, filter } from 'lodash'
import type { History, Location } from 'history'
import type { FilterAccount, FilterState } from '@src/redux/reducers/filter'

interface FilterParams {
  accountId?: string
}

export interface FilterProps {
  match?: match<FilterParams>
  history?: History
}

export function withFilter<Props>(
  ChildComponentClass: React.ComponentType<Props & FilterProps>,
  filterOptions: FilterState
) {
  return class Container extends React.PureComponent<Props & FilterProps, {}> {
    render() {
      const { match, history } = this.props
      const { params, url, path } = match || ({} as match<FilterParams>)
      const { currentAccount = {} as FilterAccount } = filterOptions
      const { id } = currentAccount || ({} as FilterAccount)
      const { location } = history || ({} as History)
      const { search = '' } = location || ({} as Location)
      const parsedUrl = split(url, '/')
      const parsedPath = split(path, '/')

      const foundAccountParamIndex = findIndex(parsedPath, x =>
        includes(x, 'accountId')
      )

      const hasAccountParam = foundAccountParamIndex !== -1

      if (
        hasAccountParam &&
        params &&
        (!params?.accountId || params?.accountId !== id) &&
        id
      ) {
        parsedUrl[foundAccountParamIndex] = id

        const newUrl = parsedUrl.join('/')
        return <Redirect to={newUrl + search} />
      }

      if (hasAccountParam && params && params?.accountId && !id) {
        const newUrl = filter(
          parsedUrl,
          (p, i) => i !== foundAccountParamIndex
        ).join('/')
        return <Redirect to={newUrl + search} />
      }

      return <ChildComponentClass {...this.props} />
    }
  }
}
